import { render, staticRenderFns } from "./DropdownTree.vue?vue&type=template&id=61ac0d8c&scoped=true&"
import script from "./DropdownTree.vue?vue&type=script&lang=js&"
export * from "./DropdownTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ac0d8c",
  null
  
)

export default component.exports